import { render, staticRenderFns } from "./subjectAuditList.vue?vue&type=template&id=fc96e46a&scoped=true&"
import script from "./subjectAuditList.vue?vue&type=script&lang=js&"
export * from "./subjectAuditList.vue?vue&type=script&lang=js&"
import style0 from "./subjectAuditList.vue?vue&type=style&index=0&id=fc96e46a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc96e46a",
  null
  
)

export default component.exports